<template>
  <div class="container">
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      loading-text="Φόρτωση υπολοίπων πελατών..."
      no-data-text="Δεν υπάρχουν δεδομένα"
      :sort-by="['date']"
      :sort-desc="true"
      class="elevation-1 my-2"
      disable-filtering>
      
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Υπόλοιπα πελατών</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <div class="mt-8">
            <v-radio-group v-model="radioGroup1" row>
              <v-radio label="Όλα" value="0" />
              <v-radio label="Πελάτες" value="1" />
              <v-radio label="Προμηθευτές" value="2" />
            </v-radio-group>

          </div>
          <v-spacer></v-spacer>
          
          <v-spacer></v-spacer>
          <table-export-menu
            title="Υπόλοιπα πελατών"
            :headers="headers"
            :items="items"
            :visible="showExport"
            button-class="mb-2"
          />

        </v-toolbar>
      </template>
      

      <template v-slot:[`item.balance`]="{ item }">
        {{ formatMoney(item.balance) }}
      </template>

      <template v-slot:[`item.bbalance`]="{ item }">
        {{ formatMoney(item.bbalance) }}
      </template>

      <template slot="body.append" v-if="showExport">
        <tr>
            <th>Σύνολα</th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th class="text-right">{{totalsSum('balance', 2)}}</th>
            <th class="text-right">{{totalsSum('bbalance', 2)}}</th>
            
        </tr>
      </template>

    </v-data-table>
  </div>
</template>

<script>
  import moment from "moment";

  export default {
    data: () => ({
      loading: true,
      allerrors : {
        
      },

      radioGroup1: "0",

      dialog: false,

      headers: [
        {
          text: 'Πελάτης',
          align: 'start',
          value: 'name',
        },
        {
          text: 'Διακ. Τίτλος',
          align: 'start',
          value: 'trade_name',
        },
        {
          text: 'ΑΦΜ',
          align: 'start',
          value: 'tax_registration_number',
        },
        {
          text: 'Αντιπρόσωπος',
          align: 'start',
          value: 'representative',
        },
        {
          text: 'Διανομέας',
          align: 'start',
          value: 'distributor',
        },
        { 
          text: 'Υπόλοιπο (1)', 
          align: 'right',
          value: 'balance',
          exportTransformer: (cell) => cell.replace('.', ',') 
        },
        { 
          text: 'Υπόλοιπο (2)', 
          align: 'right',
          value: 'bbalance',
          exportTransformer: (cell) => cell.replace('.', ',')
        }

      ],

      activeAccounts: [],
      allItems: [],

      getDataButtonDisabled: false,
      getExcelButtonDisabled: false,


    }),

    watch: {

    },

    created () {
      this.initialize()
    },

    computed: {
      showExport() {
        return this.items?.length > 0
      },

      activeCustomerIds() {
        return this.activeAccounts?.filter(x => x.customer == 1).map(x => x.account_id)
      },

      activeSupplierIds() {
        return this.activeAccounts?.filter(x => x.supplier == 1).map(x => x.account_id)
      },

      items() {

        switch (this.radioGroup1)
        {
          case "0":
            return this.allItems

          case "1":
            return this.allItems.filter(x => this.activeCustomerIds.includes(x.id))            

          case "2":
            return this.allItems.filter(x => this.activeSupplierIds.includes(x.id))
        }
      },
    },

    methods: {

      totalsSum(fieldName, fixDecimals) {
        const sum = this.items?.map(x => parseFloat(x[fieldName])).reduce((a, b) => a + b, 0)

        if (fixDecimals > 0)
          return sum.toFixed(2)

        return parseInt(sum)
      },

      excelPlease() {
        if (this.items?.length > 0 == false) {
          console.log('No items!')
          return
        }

        const transform = (line, columnDefinitions) => {
          let out = []

          columnDefinitions.forEach(columnDefinition => {

            const columnValue = line[columnDefinition.propertyName]

            if (columnDefinition.exportTransformer)
              out.push(columnDefinition.exportTransformer(columnValue))
            else
              out.push(columnValue)
          });

          return out;
        }

        const exportableColumns = this.headers.filter(x => (x.exportable ?? true) == true)
        const columnDefinitions = exportableColumns.map(x => ({ propertyName: x.value, exportTransformer: x.exportTransformer }))

        const requestBody = {
          table_headers: exportableColumns.map(x => x.text),
          table_entries: this.items.map(line => transform(line, columnDefinitions))
        }

        this.axiosDownload('/api/test', requestBody, 'αναφορά.xlsx')
      },

      axiosDownload(url, requestBody, filename) {
        this.getExcelButtonDisabled = true;

        axios({
            url: url, 
            data: requestBody,
            method: 'POST',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename); //or any other extension
            document.body.appendChild(link);
            link.click();
            this.getExcelButtonDisabled = false
        // link.remove();
        // url.remove();

        }).catch(err => { console.log(err); this.getExcelButtonDisabled = false})
      },

      formatDate(value) {
        return moment(value).format("DD/MM/YYYY")
      },

      formatMoney(amount) {
        if (amount == null)
          amount = 0.0

        return parseFloat(amount).toFixed(2)
      },


      initialize () {
        this.$store.dispatch('currentUser/getCurrentUser')

        this.getData();
        this.getFilterValues()
      },

      getFilterValues() {
       
      },
      
      getRequestParams() {
        let out = {
          
        }

        return out
      },

      getData() {
        this.loading = true;
        this.allerrors = {}

        const params = this.getRequestParams()


        this.getDataButtonDisabled = true;
        axios.post(
            '/api/reports/customers-balance', 
            {
                params: params
            }
        )
        .then(response => {
          this.allItems = response.data.data
          this.activeAccounts = response.data.accounts
        })
        .finally(() => {
          this.getDataButtonDisabled = false;
          this.loading = false;
        })
        .catch(error => { 
          if (error.response.data)
              this.allerrors = error.response.data.errors
         })
        
      },


      clearFilters() {
      }
    }
  }
</script>

<style scoped>
.v-data-table-header th {
  white-space: nowrap;
}
</style>